module.exports = __webpack_public_path__ + "static/media/IADR-logo.7ffe8fb7.svg";